import React, { PropsWithChildren } from 'react'

import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import { IApplicationState } from '@store'
import {
  fetchContentLibraryBillings,
  selectContentLibraryBillingList,
  selectIsFetchingBilling,
} from '@store/billings'
import { isEmpty } from '@utils'
import PurchaseWrapper from './Wrapper'

const PurchaseContentLibraryWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  const dispatch = useDispatch()
  const { hasPurchases, isLoading } = useSelector((state: IApplicationState) => {
    const hasPurchases = !isEmpty(selectContentLibraryBillingList(state))
    const isLoading = !hasPurchases && !!selectIsFetchingBilling(state)
    return { isLoading, hasPurchases }
  }, shallowEqual)

  return (
    <PurchaseWrapper
      hasPurchases={hasPurchases}
      isLoading={isLoading}
      enableFetch={true}
      fetchList={() => dispatch(fetchContentLibraryBillings())}
    >
      {children}
    </PurchaseWrapper>
  )
}

export default PurchaseContentLibraryWrapper
